import { GetExpensablesDocument } from 'generated/resources/graphql'

import { useLazyQuery } from 'modules/core/hooks/useQuery'

import { UseExpensable } from './useExpensable'

type FetchExpensable = Omit<UseExpensable, 'resourceType' | 'resourceId' | 'skip'>

export const useLazyExpensable = () => {
  const [fetchExpensables, { loading }] = useLazyQuery(GetExpensablesDocument)

  const fetch = async ({
    id,
    employeeId,
    includeProjects = false,
    includeTransactions = false,
    includeJournalEntries = false,
    ...variables
  }: FetchExpensable) => {
    const ids = id ? [id] : null
    const employeeIds = employeeId ? [employeeId] : null

    if (!ids) return Promise.resolve()

    const { data } = await fetchExpensables({
      variables: {
        ids,
        employeeIds,
        includeProjects,
        includeTransactions,
        includeJournalEntries,
        ...variables,
      },
    })

    return data?.expenses?.expensablesConnection?.nodes?.[0]
  }

  return { loading, fetch }
}
